import React, {useState, useRef, useCallback, useEffect} from 'react';
import {Link, useHistory, useParams} from 'react-router-dom';
import Form, {
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule, PatternRule, GroupItem, SimpleItem
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { useAuth } from '../../contexts/auth';
import './login-form.scss';
// import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
// import {faRefresh} from "@fortawesome/free-solid-svg-icons";
// import ScrollView from "devextreme-react/scroll-view";
// import {Popup} from "devextreme-react/popup";
// import {TextBox} from "devextreme-react";
// import {Button} from "devextreme-react/button";
// import SixDigitInput from "../six-digit-input/six-digit-input";
import {generateFingerpint, getAuthSettings, sendPhone} from "../../api/auth";//, sendPhoneCode generateFingerpint,
import LoadPanel from "devextreme-react/load-panel";
import TabPanel from 'devextreme-react/tab-panel';

import SmsPopupDifferent, {formatSmsCountdown, useSmsTypeOpTimer} from "../sms-popup/sms-popup-different";
import {getMaintenanceStatus} from "../../api/maintenance";
import {getHHmmddMMyyyy} from "../../utils/date.utils";

const LoginForm = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const formData = useRef({});
  const eyeclose = require("./../../assets/eyeclose.svg").default
  const eyeopen = require("./../../assets/eyeopen.svg").default
  const loginTabs = [{ title: 'E-mail', val: 0 }, { title: 'Телефон', val: 1 }];
  const [passwordIcon, setPasswordIcon] = useState(eyeclose);
  const [selectedValueRadio, setSelectedValueRadio] = useState(0);
  const [loading, setLoading] = useState(false);
  const [authSettings, setAuthSettings] = useState( {})
  // const [codeSms, setCodeSms] = useState('19735')
  // const [disableSms, setDisableSms] = useState(false)
  const [messageSendSms, setMessageSendSms] = useState('Ошибка')
  const [uid, setUid] = useState(null)
  const phoneEditorOptions = {
    mask: '+7 (YX0) 000-0000',
    maskRules: { X: /[01-9]/, Y: /[9]/ },
    maskInvalidMessage: 'Некорректный номер телефона',
    stylingMode: 'filled', placeholder: 'Телефон',
    valueChangeEvent: 'keyup'
  };
  // const [codVerifyEnabled, setCodVerifyEnabled] = useState(false)
  // const [actionType, setActionType] = useState(null);
  const [typeOp, setTypeOp] = useState(1);
  const [messageLoadPanel, setMessageLoadPanel] = useState(`Отправка СМС...`);
  const [timerStart, setTimerStart] = useState(false)
  const [lifeTimeSeconds, setLifeTimeSeconds] = useState(null);
  const loginSmsRemaining = useSmsTypeOpTimer(1)
  const registerSmsRemaining = useSmsTypeOpTimer(0)
  const [maintenanceStatus, setMaintenanceStatus] = useState(false);
  const [rk, setRk] = useState('');
  const { admin } = useParams()
  let formRef = useRef(null)
  const isMountedRef = useRef(false);
  const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'

  // Эффект для управления флагом
  useEffect(() => {
    (async function () {
      try {
        window.localStorage.removeItem( "originalUser" )
        const res = await getAuthSettings()
        setAuthSettings(res?.data)
      } catch (e) {
        notify(e.message, 'error', 5000)
      }
    })()
  }, [])

  useEffect(() => {
    isMountedRef.current = true;
    const bytes = new Uint8Array(16);
    // randomUUID только по https
    const token = typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : window.crypto.getRandomValues(bytes).join('');
    document.cookie = `_rk=${token}; SameSite=Strict; path=/`;
    setRk(token);
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    (async function () {
      try {
        const res = await getMaintenanceStatus()
        setMaintenanceStatus(res?.data)
      } catch (e) {
        notify(e.message, 'error', 5000)
      }
    })()
  }, [])

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    // вход по email
    if (!selectedValueRadio) {
      const {email, password} = formData.current;
      setMessageLoadPanel(`Загрузка...`)
      setLoading(true);

      try {
        const result = await signIn(email, password);

        // Проверяем, что компонент ещё смонтирован перед обновлением состояния
        if (!isMountedRef.current) return;

        if (!result.isOk) {
          //Расскомментировал, т.к. нужно для неправильных кредов
          notify(result.message, 'error', 5000);
          if (result.status && result.status === 'reset') {
            history.push('/reset-password')
          } else {
            notify(result.message, 'error', 5000);
          }
        }
      } catch (e) {
        if (isMountedRef.current) {
          notify(e.message, 'error', 5000);
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    } else {
      // Вход по SMS
      if (isMountedRef.current) {
        setMessageLoadPanel(`Отправка СМС...`);
        setTypeOp(1);
        setLoading(true);
      }
      try {
        setMessageLoadPanel(`Отправка СМС...`)
        setTypeOp(1)
        setLoading(true);
        const {phone} = formData.current;
        const fingerprint = await generateFingerpint()
        const result = await sendPhone('+7' + phone, 1, fingerprint, rk);

        // Проверяем монтирование перед обновлением состояния
        if (!isMountedRef.current) return;

        if (!result.uid) {
          notify(result.message, 'error', 5000);
        } else {
          setUid(result.uid);
          setMessageSendSms(result.message);
          setTimerStart(true);
        }
      } catch (e) {
        if (isMountedRef.current) {
          notify(e.message, 'error', 5000);
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    }

  }, [signIn, history, selectedValueRadio, rk]);

  const onCreateAccountClick = useCallback(async () => {
    if (authSettings?.smsNotify && selectedValueRadio) { // все ЛКК
      if (!formRef.current?.instance.validate().isValid) {
        notify('Введите номер телефона, чтобы начать регистрацию', 'error', 5000)
        return
      } //Только у кого smsNotify true
      try {
        setTypeOp(0)
        setLoading(true);
        const {phone} = formData.current;
        const result = await sendPhone('+7' + phone, 0, undefined, rk);
        if (!result.uid) {
          notify(result.message, 'error', 5000);
        } else {
          setUid(result.uid)
          setMessageSendSms(result.message)
          setTimerStart(true)
        }
      } catch (e) {
        notify(e.message, 'error', 5000);
      } finally {
        setLoading(false);
      }
    } else {
      window.localStorage.setItem("fromPhoneAuth",'false')
      history.push('/create-account')
    }



  }, [history, selectedValueRadio, authSettings?.smsNotify, rk]);

  const [passwordMode, setPasswordMode] = useState('password')

  const passwordEditorOptions = {
    stylingMode: 'filled',
    mode: passwordMode,
    buttons: [{
      name: 'Пароль',
      location: 'after',
      options: {
        icon: passwordIcon,
        type: 'default',
        onClick() {
          setPasswordMode(passwordMode === 'text' ? 'password' : 'text');
          setPasswordIcon(passwordIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  };

  // const handleButtonClick = (type) => {
  //   setActionType(type);
  // };


  return (
      <>
        <LoadPanel message={messageLoadPanel} visible={loading} />
        {!maintenanceStatus?.isActive || admin === 'showlogin' ?
            <>
            <form className={'login-form'} onSubmit={onSubmit}>
              <Form formData={formData.current} ref={formRef}
                    labelMode="static"
                    labelLocation="left">
                {authSettings?.smsNotify &&
                    <SimpleItem>
                      <TabPanel
                          className="login-form-tabs"
                          width="100%"
                          height="auto"
                          animationEnabled={false}
                          swipeEnabled={false}
                          dataSource={loginTabs}
                          selectedIndex={selectedValueRadio}
                          onSelectedIndexChange={setSelectedValueRadio}
                          itemTitleRender={(item) => item.title}
                          itemRender={() => null}
                      />
                    </SimpleItem>
                }
                {!selectedValueRadio ?
                    <GroupItem>
                      <SimpleItem
                          dataField={'email'}
                          editorType={'dxTextBox'}
                          editorOptions={emailEditorOptions}
                      >
                        <RequiredRule message="Email задан неверно" />
                        <EmailRule message="Email задан неверно" />
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem
                          dataField={'password'}
                          editorType={'dxTextBox'}
                          editorOptions={passwordEditorOptions}
                      >
                        <RequiredRule message="Пароль задан неверно" />
                        <Label text="Пароль" />
                      </SimpleItem>
                    </GroupItem>
                    :
                    <GroupItem>
                      <SimpleItem
                          dataField={'phone'}
                          editorType={'dxTextBox'}
                          editorOptions={phoneEditorOptions}
                          name="phone"
                      >
                        <PatternRule
                            message="Некорректный формат"
                            pattern={/[9]\d{9}$/}
                        />
                        <Label text="Телефон"/>
                        <RequiredRule message="Телефон обязателен" />
                      </SimpleItem>
                    </GroupItem>
                }
                {/* <Item
          dataField={'rememberMe'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item>*/}

                <SimpleItem>
                  <SmsPopupDifferent typeOp={typeOp} formData={formData.current}
                            setTimerStart={setTimerStart}
                            timerStart={timerStart}
                            messageSendSms={messageSendSms}
                            selectedValueRadio={!!selectedValueRadio}
                            uid={uid}
                            authSettings={authSettings}
                            lifeTimeSeconds={lifeTimeSeconds}
                            setLifeTimeSeconds={setLifeTimeSeconds}
                            setMessageSendSms={setMessageSendSms} ></SmsPopupDifferent>
                </SimpleItem>
                <ButtonItem name={'enter'}>
                  <ButtonOptions
                      width={'100%'}
                      type={'default'}
                      disabled={(loginSmsRemaining && selectedValueRadio) || loading}
                      useSubmitBehavior={true}
                  >
            <span className="dx-button-text tatsbyt-text-bold">
              {
                loading
                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                    : !selectedValueRadio ? 'Войти'
                        : loginSmsRemaining ? `Получить код ${formatSmsCountdown(loginSmsRemaining)}`
                            : 'Получить код'
              }
            </span>
                  </ButtonOptions>
                </ButtonItem>
                <ButtonItem name={'registr'}>
                  <ButtonOptions
                      text={selectedValueRadio && registerSmsRemaining
                          ? `Зарегистрироваться ${formatSmsCountdown(registerSmsRemaining)}`
                          : 'Зарегистрироваться'}
                      width={'100%'}
                      disabled={!!(authSettings?.smsNotify && selectedValueRadio && registerSmsRemaining) || loading}
                      onClick={onCreateAccountClick}
                  />
                </ButtonItem>
                <GroupItem>
                  {!selectedValueRadio &&
                      <SimpleItem>
                        <div className={'link'}>
                          <Link to={'/reset-password'}>Забыли пароль?</Link>
                        </div>
                      </SimpleItem>
                  }
                </GroupItem>

                {envTat &&
                    <SimpleItem>
                      <div className={'instruction'}>
                        <a href="/Руководство_пользователя_ЛКК.pdf" target="_blank" rel="noopener noreferrer">Инструкция пользователя</a>
                      </div>
                    </SimpleItem>
                }
              </Form>
            </form>
            <div className={`alert alert-${envTat ? "warning": "primary"} mt-2 mb-0`} role="alert">
              <i className="dx-icon-attention me-2"></i>
              Для стабильной и безопасной работы сайта мы рекомендуем установить защитные сертификаты Минцифры.<br/>
              <a href="https://www.gosuslugi.ru/crt" target="_blank" rel="noopener noreferrer">Cсылка на инструкцию</a>
            </div>
            </>
            :
            <div className="alert alert-warning mt-4" role="alert">
              <i className="dx-icon-attention me-2"></i>
              Уважаемые клиенты! В связи с проведением регламентных, технических работ доступ к Личному кабинету юридических лиц {process.env.REACT_APP_FULL_OF_NAME} закрыт до {getHHmmddMMyyyy(maintenanceStatus.endTime)}&nbsp;г.
              Приносим извинения за доставленные неудобства. Рекомендуем обновить страницу после указанного времени окончания работ.
              {envTat &&
                  <div class="content-block">
                    <p class="mb-3">Вы можете воспользоваться другими способами оплаты задолженности и передачи показаний приборов учёта:</p>

                    <ul class="list-unstyled">
                      <li class="mb-2">
                        <i class="dx-icon dx-icon-money mr-2 text-primary"></i>
                        <a href="https://tatenergosbyt.ru/b2b/payment/how/" target="_blank" rel="noopener noreferrer">
                          Как оплатить задолженность
                        </a>
                      </li>
                      <li class="mb-2">
                        <i class="dx-icon dx-icon-chart mr-2 text-primary"></i>
                        <a href="https://tatenergosbyt.ru/b2b/uchet/poryadok-peredachi-pokazanij/#uchet__section" target="_blank" rel="noopener noreferrer">
                          Как передать показания приборов учёта
                        </a>
                      </li>
                    </ul>
                  </div>
              }
            </div>

        }
      </>
  );
}

const emailEditorOptions = { stylingMode: 'filled', mode: 'email', valueChangeEvent: 'keyup' };
//const rememberMeEditorOptions = { text: 'Запомнить меня', elementAttr: { class: 'form-text' } };

export default LoginForm


